import React from 'react';
 
const ReportTypeList = ({ reportTypes, onReportSelect }) => {
    return (
        <section>
            <div className="consultation-types">
                <h3>Available Report Types</h3>
                <p className="refer-subtitle">Click on any report type below to generate your personalized report</p>
                <div className="credit-packages report-card-content">  
                    {reportTypes.map((report) => (
                        <div
                            key={report.id}
                            className="consultation-card report-card"
                            onClick={() => onReportSelect(report)}
                        >
                            <div className="service-content">
                                <h4 className="service-title">{report.name}</h4>
                                <p className="service-desc">{report.description}</p>
                                <span className='consult-price'>
                                    {report.credits} Credits
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
 
export default ReportTypeList;